import { ReactNode } from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ChatAssistant } from "../ChatAssistant";
import { NotificationBanner } from "../NotificationBanner";
import { useRadixPointerEventsGuard } from "@/hooks/useRadixPointerEventsGuard";

interface LayoutProps {
  children: ReactNode;
  /** When true, the first child is a fullscreen hero that should not have top padding */
  hasHero?: boolean;
}

export function Layout({ children, hasHero = false }: LayoutProps) {
  useRadixPointerEventsGuard();

  return (
    <div className="min-h-screen flex flex-col">
      <NotificationBanner />
      <Navbar />
      <main className={`flex-1 ${hasHero ? '' : 'pt-20'}`}>
        {children}
      </main>
      <Footer />
      <ChatAssistant />
    </div>
  );
}
